/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#time-picker.ng-invalid[_ngcontent-%COMP%] > table[_ngcontent-%COMP%] > tbody[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{border-left:5px solid #ca4855}"];
export { styles as styles };
